import { JDialogContext } from '@/contexts/JDialogContext';
import { useContext } from 'react';

const useJDialog = () => {
  const context = useContext(JDialogContext);
  if (!context) {
    throw new Error('useJDialog must be used within a JDialogProvider');
  }
  return context;
};

export default useJDialog;
